import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import {
  TRACE_AGENT_NAMES,
  type TraceAgentName,
} from '@terra/shared-contracts-trace';

export const isTraceAgentName = (
  agentName: string | undefined,
): agentName is TraceAgentName =>
  TRACE_AGENT_NAMES.some((knownAgentName) => knownAgentName === agentName);

export const useTraceAgentLabel = () => {
  const t = useTranslations('designSystem.signals.drawer.agent');

  return useCallback(
    (agentName: string | undefined): string | undefined =>
      isTraceAgentName(agentName) ? t(agentName) : agentName,
    [t],
  );
};
